import { Spin } from "antd";
import { useImagenFirma } from "./useImagenFirma";
import styles from "../../shared/Evaluaciones.module.css";

export function ImagenFirma({ evaluacionEmpleadoID, tipoFirma, rol }) {
  const { imagen, error } = useImagenFirma(evaluacionEmpleadoID, tipoFirma);

  if (error) return <p className={styles.error} role="alert">{error}</p>;
  if (!imagen) return <Spin />;

  return <img className={styles.signatureImage} src={imagen} alt={`Firma de ${rol}`} />;
}
